import { i18n } from "services/i18nService";

import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  { apiName: "expandKitsOnSalesOrder", component: "FrmCheckbox" },
  { apiName: "salesOrderText", component: "FrmResizeTextField", maxLength: 50 },
  {
    apiName: "salesOrderNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.SALES_ORDER.fullString,
    hasInputLabel: true,
  },
  { apiName: "replyEmailSO", component: "FrmEmail", maxLength: 255 },
  {
    apiName: "salesOrderEmail",
    component: "FrmResizeTextField",
    explanationOverride: (
      <>
        {i18n("settings.sales.salesOrders.salesOrderEmail.explanation.1")}
        <p>
          {i18n("settings.sales.salesOrders.salesOrderEmail.explanation.2")}
        </p>
        <div>
          {i18n("settings.sales.salesOrders.salesOrderEmail.explanation.3")}
        </div>
        <div>
          {i18n("settings.sales.salesOrders.salesOrderEmail.explanation.4")}
        </div>
        <div>
          {i18n("settings.sales.salesOrders.salesOrderEmail.explanation.5")}
        </div>
      </>
    ),
  },
  { apiName: "salesOrderFooter", component: "FrmResizeTextField" },
  {
    apiName: "defaultCCSalesOrder",
    component: "FrmEmail",
    maxLength: 255,
  },
  { apiName: "editLocksEnabled", component: "FrmCheckbox" },
];
